import { useColorScheme } from "@contember/react-utils";
import { listClassName, colorSchemeClassName, contentThemeClassName, controlsThemeClassName } from "@contember/utilities";
import { toEnumStateClass } from "../../../utils/toEnumStateClass.js";
import { toStateClass } from "../../../utils/toStateClass.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
function useInputClassName({
  // ControlStateProps
  active,
  disabled,
  loading,
  readOnly,
  required,
  focused,
  hovered,
  // ControlDisplayProps
  className: outerClassName,
  distinction,
  intent,
  scheme,
  size,
  // ValidationStateProps
  validationState,
  ...restNotImplemented
}) {
  let finalIntent = disabled ? "default" : intent;
  if (validationState === "invalid") {
    finalIntent = "danger";
  }
  const colorScheme = useColorScheme();
  return listClassName([
    toStateClass("active", active),
    toStateClass("disabled", disabled),
    toStateClass("focused", focused),
    toStateClass("hovered", hovered),
    toStateClass("loading", loading),
    toStateClass("read-only", readOnly),
    toStateClass("required", required),
    colorSchemeClassName(!disabled ? scheme ?? colorScheme : colorScheme),
    contentThemeClassName(finalIntent),
    controlsThemeClassName(finalIntent),
    toEnumViewClass(size),
    toEnumViewClass(distinction),
    toEnumStateClass(validationState),
    outerClassName
  ]);
}
export {
  useInputClassName
};
//# sourceMappingURL=useInputClassName.js.map
